<template>
 <ion-page id="signoff-page">
    <ion-content>
      <div :class="{ 'text-dark' : isDark,'text-light' : !isDark }" 
           :style="styleOneFrame" :key="menuTrigger">
  
        <ion-item>
          <h3>{{ t("Email Verification Check") }}</h3>
        </ion-item>
          <div v-if="hasError">
            <ion-item color="warning">
              {{ message }}
            </ion-item>
          </div>
          <div v-else>
            <ion-item>
              {{ message }}
            </ion-item>
          </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script setup>

// https://stackoverflow.com/questions/35914069/how-can-i-get-query-parameters-from-a-url-in-vue-js

import { IonLabel,IonCheckbox, IonGrid,IonRow,IonCol,IonButton,IonItem,IonInput,IonPage, IonContent, modalController } from '@ionic/vue';

import ModalErrorMessage from '@/components/ModalErrorMessage.vue'
import { t } from '@/composables/translateText.js'

import { ref, watch } from 'vue'
import { useConnectionStore } from '@/stores/connectionStore';
import { useWindowSizeStore } from '@/stores/windowSizeStore';
import { useGetData } from '@/composables/getData.js'
import { doStartupCheck } from '@/composables/startupCheck.js'
import { availableWidthHeight }  from '@/composables/screenSize'

const connectionStore = useConnectionStore()

const isDark = ref(connectionStore.getDarkmode != "light")
const menuTrigger = ref(0)

const windowSizeStore = useWindowSizeStore()
const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] })

const urlParams =  new URLSearchParams(window.location.search)

const hasError = ref(false)
const message = ref("")
var verify = ""
var email = ""

var url_v = localStorage.getItem("url_v")
var url_e = localStorage.getItem("url_e")

if (url_v == null || url_e == null) {
  hasError.value = true
  message.value = "The necessary URL parameters aren't there. If this persists, please contact support@chessvis.com"
}
else {
  hasError.value = false
  verify = url_v
  email = decodeURIComponent(url_e)
  sendVerification(verify,email)
}

const styleOneFrame = ref({
   position : "absolute",
   "overflow-y" : "scroll",
   top : "0px",
   left : "100px",
   width: "100px",
   height : "100px"
 })
 
updateWidthHeights()

function updateWidthHeights() {

  const availableSpace = availableWidthHeight()
  const oneframePositionTop = availableSpace.topIndent
  const oneframePositionLeft = availableSpace.leftRightIndent + availableSpace.leftIndent
  const oneframeHeight = availableSpace.height - oneframePositionTop + availableSpace.topIndent
  const oneframeWidth = availableSpace.width - availableSpace.leftRightIndent * 2

  styleOneFrame.value.height = oneframeHeight + "px"
  styleOneFrame.value.width = oneframeWidth + "px"
  styleOneFrame.value.top = oneframePositionTop + "px"
  styleOneFrame.value.left = oneframePositionLeft + "px"

  //console.log("frame size",styleOneFrame.value)
}

const openErrorModal = async (programName,errorMessage) => {
    const modal = await modalController.create({
      component: ModalErrorMessage,
      componentProps: {
        type : "commError",
        program : programName ,
        errorMessage : errorMessage
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();
  };

watch(() => windowSizeStore.getWindowSize, () => {
    //console.log('*********** window size changes detected')
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    //console.log("*** logoff new window size",windowSizeRef.value)
    updateWidthHeights()
    menuTrigger.value++
  })
  
function processJsonResponse (json) {
  //console.log(" ******** email verification callback",json)
  if (json.hasOwnProperty('error')) {
    openErrorModal(json['programRun'],json['error'])
    return;
  }
  switch (json['stat']) {
    case 'g' :
      message.value = t("Email Verified")
      hasError.value = false
      break
    default :
      message.value = json['stat']
      hasError.value = true
      break;
  }
  doStartupCheck(true)
}

function sendVerification(verify,email) {
  message.value = t("processing email verification") + "...."
  var formData = { 
    e : email, 
    v : verify 
  }
  useGetData("process_email_verification.php", formData, processJsonResponse)
}



</script>

<style scoped>

.item{
  margin:10px auto;
}

</style>
